import React, { useEffect } from 'react';
import SettingContainer from '../SettingContainer';
import { useConfig } from '../../../DataStore/ConfigContext';
import { useTheme } from '../../../DataStore/ThemeContext';

/* Refined InfoRow for better alignment */
const InfoRow = ({ label, children }) => (
  <div className="info-row-container py-3">
    <div className="info-label">{label}</div>
    <div className="info-value">{children || <span className="text-muted italic">Not Provided</span>}</div>
  </div>
);

const CompanyProfile = () => {
  const { company, getCompanyProfile } = useConfig();
  const { openSettings } = useTheme();

  useEffect(() => { getCompanyProfile(); }, []);

  const handleEditProfile  = () => openSettings('Edit Profile', 'EditProfile', company);
  const handleUploadLogo  = () => openSettings('Upload Logo', 'UploadLogo', null, "Upload");

  const Menu = () => (
    <>
      <button type="button" className="dropdown-item" onClick={handleEditProfile}>
        <i className="dropdown-icon fa fa-edit" /> <span>Edit Profile</span>
      </button>
      <button type="button" className="dropdown-item" onClick={handleUploadLogo}>
        <i className="dropdown-icon fa-solid fa-cloud-arrow-up" /> <span>Change Logo</span>
      </button>
      <button type="button" className="dropdown-item" onClick={() => getCompanyProfile(true)}>
        <i className="dropdown-icon fa fa-sync" /> <span>Refresh Data</span>
      </button>
    </>
  );

  if (!company) return null;

  return (
    <SettingContainer title="Company Profile" icon="fa-solid fa-building-shield" Menu={Menu}>
      <div className="company-profile-wrapper">
        <div className="row">
          {/* Brand Card - Left Side */}
          <div className="col-lg-4 mb-4">
            <div className="brand-card">
              <div className="logo-placeholder">
                {company.badge ? (
                  <img src={company.badge} alt="Logo" className="img-fluid main-logo" />
                ) : (
                  <div className="no-logo-state">
                    <i className="fa-solid fa-image mb-2"></i>
                    <span>No Logo uploaded</span>
                  </div>
                )}
              </div>

              <div className="brand-details text-center mt-3">
                <h4 className="brand-title">
                  {company.short_name} <span className="brand-initials">({company.initials})</span>
                </h4>
                <p className="brand-motto">
                    {company.motto ? `“${company.motto}”` : '“Update your catch phrase here”'}
                </p>
              </div>

              <div className="brand-actions mt-4">
                <button className="btn btn-modern-outline w-100 mb-2" onClick={handleUploadLogo}>
                  <i className="fa-solid fa-shield-halved mr-2" /> Change Logo
                </button>
                <button className="btn btn-modern-primary w-100" onClick={handleEditProfile}>
                  <i className="fa-solid fa-pen-to-square mr-2" /> Edit Profile
                </button>
              </div>
            </div>
          </div>

          {/* Details Panel - Right Side */}
          <div className="col-lg-8">
            <div className="details-panel">
              <InfoRow label="Company Name">{company.client_name}</InfoRow>
              <InfoRow label="Email Address">{company.email_address}</InfoRow>
              <InfoRow label="Telephone">{company.telephone}</InfoRow>
              <InfoRow label="Physical Address">{company.address}</InfoRow>
              <InfoRow label="Website">
                {company.website && (
                  <a href={company.website} target="_blank" rel="noreferrer" className="website-link">
                    <i className="fa-solid fa-arrow-up-right-from-square mr-1" /> {company.website}
                  </a>
                )}
              </InfoRow>
              
              <div className="info-row-container py-3 no-border">
                <div className="info-label">Company Code</div>
                <div className="info-value">
                  <span className="code-badge">{company.company_code}</span>
                </div>
              </div>

              <div className="profile-footer-note mt-4">
                <i className="fa-solid fa-circle-info mr-2"></i>
                Keep your company details up to date. These values appear on invoices, statements, and automated reports.
              </div>
            </div>
          </div>
        </div>
      </div>
    </SettingContainer>
  );
};

export default CompanyProfile;